import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export const PriceBreakdownDiscounts = ({ discounts, currency }) => {
  return discounts.map((discount, i) => {
    const discountDescription =
      discount.apply_as === 'PERCENT_OFF' ? (
        <FormattedMessage
          id='inbox.prepare_discount_fields.summary_percent_off'
          defaultMessage='{value}% off'
          values={{ value: discount.value }}
        />
      ) : (
        <FormattedMessage
          id='inbox.prepare_discount_fields.summary_value_off'
          defaultMessage='{value} off'
          values={{
            value: (
              <FormattedNumber
                value={discount.value}
                currency={currency}
                style='currency'
              />
            )
          }}
        />
      );

    const maxAmountDescripton = !!discount.max_amount && (
      <FormattedMessage
        id='inbox.prepare_discount_fields.summary_max_amount'
        defaultMessage=', up to {amount}'
        values={{
          amount: (
            <FormattedNumber
              value={discount.max_amount}
              currency={currency}
              style='currency'
            />
          )
        }}
      />
    );
    return (
      <div
        key={`other-discounts-${i}`}
        className={classNames('flex space-between', { 'margin-sm-top': i > 0 })}
        data-testing-id='price-breakdown-discounts'
      >
        <span
          className='discount-text'
          data-testing-id='price-breakdown-discounts-label'
        >
          {discount.discount_str || (
            <span>
              {discount.title}
              <br />
              {discountDescription}
              {maxAmountDescripton}
            </span>
          )}
        </span>
        <span
          className='text-green'
          data-testing-id='price-breakdown-discounts-amount'
        >
          <FormattedNumber
            value={-discount.discount_amount}
            currency={currency}
            style='currency'
          />
        </span>
      </div>
    );
  });
};

PriceBreakdownDiscounts.propTypes = {
  discounts: PropTypes.arrayOf(PropTypes.object).isRequired,
  currency: PropTypes.string.isRequired
};
